module.exports = __webpack_public_path__ + "img/product_express_disabled_mobile.bbcf5eb6.png";